export const getters = {
    categories: state => state.categories,
    categoriesById: state => ids => state.categories.filter(category => ids.includes(category.id.toString()))
}